import { MapContainer, Marker, TileLayer } from "react-leaflet";
import { useAppSelector } from "../../hooks";
import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { getByPath } from "../../features/Sensors/SensorUtils";
import L from "leaflet";
import { c_heading, c_latitude, c_longitude } from "../../config/uiconfig"
// import "leaflet-rotatedmarker";

function RecenterMap({ position }: { position: [number, number] }) {
    const map = useMap();

    useEffect(() => {
        map.setView(position);
    }, [position, map]);

    return null;
}

function Map(){
    

    const boatIcon = L.divIcon({
        className: "custom-boat-icon",
        html: `
            <svg width="40" height="40" viewBox="0 0 24 24" fill="red" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L15 8H9L12 2Z" />
                <path d="M9 8H15L18 20H6L9 8Z" />
            </svg>
        `,
        iconSize: [40, 40],
        iconAnchor: [20, 20], // center for rotation
    });
    const waypointIcon = L.divIcon({
        className: "custom-waypoint-icon",
        html: `
            <svg width="30" height="30" viewBox="0 0 24 24" fill="blue" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="6" />
            </svg>
        `,
        iconSize: [30, 30],
        iconAnchor: [15, 15],
    });

    const measurements = useAppSelector(state => state.Measurements.measurements);
    const waypoint_north = useAppSelector(state => state.Waypoint.north);
    const waypoint_east = useAppSelector(state => state.Waypoint.east);

    const lat = getByPath(c_latitude, measurements)?.value;
    const lng = getByPath(c_longitude, measurements)?.value;
    const headingRaw = getByPath(c_heading, measurements)?.value;
    
    const heading = headingRaw != null ? Number(headingRaw) : 0;

    const position: [number, number] | null =
        lat != null && lng != null
            ? [Number(lat), Number(lng)]
            : null;

    const waypointPosition: [number, number] | null =
        waypoint_north != null && waypoint_east != null
            ? [Number(waypoint_north), Number(waypoint_east)]
            : null;
    if (!position) return null;

    return (
        <MapContainer
            style={{ minWidth: "100%", height: "500px" }}
            center={position}
            zoom={10}
        >
            <TileLayer
                attribution='Source: GEBCO, NOAA, National Geographic, DeLorme, NAVTEQ, and Esri'
                url='https://services.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}'
            />

            <TileLayer
                url="https://services.arcgisonline.com/ArcGIS/rest/services/Ocean/World_Ocean_Reference/MapServer/tile/{z}/{y}/{x}"
                attribution='Tiles &copy; Esri &mdash; Ocean reference labels'
            />

            <Marker position={position} icon={boatIcon} rotationAngle={heading} rotationOrigin="center"/>
            {waypointPosition && (
                <Marker
                    position={waypointPosition}
                    icon={waypointIcon}
                >
                </Marker>
            )}

            <RecenterMap position={position}  />
        </MapContainer>
    );
}

export default Map;